export type SolutionSummary = {
  code: string
  slug: string
  to: string
  title: string
  claim: string
  description: string
  highlights: string[]
  image: string
  cta: string
}

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/5c089538-1d42-40fa-bd9f-b1c2c4ee986d.jpg',
  controlTower: 'https://cdn.magicpatterns.com/patterns/generated-images/39f77119-6b0d-4e24-875d-9cc838a57ae0.jpg',
  warehouse: 'https://cdn.magicpatterns.com/patterns/generated-images/5291c9db-e5c6-4b39-9b89-3b721a4e036c.jpg',
  fleet: 'https://cdn.magicpatterns.com/patterns/generated-images/ada417b5-21c8-4148-83d4-3c70e0aa9091.jpg',
  hse: 'https://cdn.magicpatterns.com/patterns/generated-images/50cfc927-247e-421f-933a-10bea69bdade.jpg',
  facility: 'https://cdn.magicpatterns.com/patterns/generated-images/663c7980-c2c4-45c1-9a7a-8338572fcf9b.jpg',
  maintenance: 'https://cdn.magicpatterns.com/patterns/generated-images/a4cbc182-16fe-4dae-b725-dbae27010934.jpg',
  sustainability: 'https://cdn.magicpatterns.com/patterns/generated-images/8a867bb0-ddc0-4bd2-81d4-41be2db4987c.jpg',
  greenSpaces: 'https://cdn.magicpatterns.com/patterns/generated-images/e141edb3-6290-4db8-a3df-65cb91236ea9.jpg',
  team: 'https://cdn.magicpatterns.com/patterns/generated-images/3e540755-bea5-4bd3-be5a-d28a4c9a2cac.jpg',
}

export const SOLUTIONS: SolutionSummary[] = [
  {
    code: '01',
    slug: 'logistica-supply-chain',
    to: '/soluciones/logistica-supply-chain',
    title: 'Logística & Supply Chain',
    claim: 'Diseñamos, implementamos y controlamos operaciones logísticas de punta a punta.',
    description:
      'Socio estratégico y operativo: desde el diseño de la red y las licitaciones hasta la ejecución diaria, los KPIs y la mejora continua.',
    highlights: [
      'Consultoría y diseño de cadenas de suministro',
      'Licitaciones de transporte y de depósitos',
      'Warehousing y soluciones de almacenaje',
      'KPIs, SLA y excelencia operacional',
    ],
    image: IMAGES.warehouse,
    cta: 'Analizar mi operación logística',
  },
  {
    code: '02',
    slug: 'transporte-distribucion',
    to: '/soluciones/transporte-distribucion',
    title: 'Transporte & Distribución',
    claim: 'Capacidad de transporte para todo el territorio argentino.',
    description:
      'Modelo mixto de activos fijos y red 3PL, con gestión integral de transportistas, documentación y seguimiento.',
    highlights: [
      '20 unidades de activos fijos + red 3PL',
      'Más de 150 unidades habilitadas disponibles',
      'Cargas generales, industriales e IMO cuando corresponda',
      'Operaciones locales, nacionales y multimodales',
    ],
    image: IMAGES.fleet,
    cta: 'Solicitar capacidad de transporte',
  },
  {
    code: '03',
    slug: 'control-tower',
    to: '/soluciones/control-tower',
    title: 'Control Tower',
    claim: 'Vea su operación antes de que se convierta en un problema.',
    description:
      'Coordinación operativa, Account Manager, seguimiento de transportes, control documental, KPIs y medición de SLA en una vista única.',
    highlights: [
      'Seguimiento y coordinación operacional',
      'Call Center post carga',
      'Medición de SLA y evaluación de proveedores',
      'Del dato a la decisión: detección temprana de desvíos',
    ],
    image: IMAGES.controlTower,
    cta: 'Ver el Control Tower',
  },
  {
    code: '04',
    slug: 'facility-management',
    to: '/soluciones/facility-management',
    title: 'Facility Management',
    claim: 'Todo lo que mantiene funcionando una instalación.',
    description:
      'Integramos mantenimiento, limpieza, servicios técnicos y espacios exteriores dentro de una única gestión.',
    highlights: [
      'Limpieza corporativa e industrial',
      'Mantenimiento técnico preventivo y correctivo',
      'Control de plagas y saneamiento ambiental',
      'Parquización y poda en altura',
    ],
    image: IMAGES.facility,
    cta: 'Cotizar Facility Management',
  },
  {
    code: '05',
    slug: 'hse',
    to: '/soluciones/hse',
    title: 'HSE & Seguridad',
    claim: 'La seguridad no se audita al final. Se integra a la operación desde el comienzo.',
    description:
      'Auditorías, matriz legal, control de cumplimiento, capacitaciones, EPP, mantenimiento y gestión de incidentes.',
    highlights: [
      'Auditorías HSE y a transportistas',
      'Matriz legal de seguridad y medio ambiente',
      'Programa completo de capacitaciones',
      'Investigación de accidentes y planes de acción',
    ],
    image: IMAGES.hse,
    cta: 'Solicitar evaluación HSE',
  },
  {
    code: '06',
    slug: 'sustentabilidad',
    to: '/soluciones/sustentabilidad',
    title: 'Sustentabilidad',
    claim: 'Medir. Reducir. Mejorar.',
    description:
      'Medición de huella de carbono, reportes mensuales de CO₂, análisis de operaciones y oportunidades de modernización de flota.',
    highlights: [
      'Medición de huella de carbono',
      'Reportes mensuales de CO₂',
      'Indicadores ambientales y mejora continua',
      'Tecnologías sustentables aplicadas',
    ],
    image: IMAGES.sustainability,
    cta: 'Solicitar propuesta',
  },
]

export const SUPPLY_CHAIN_GROUPS = [
  {
    title: 'Consultoría & estrategia',
    items: [
      'Consultoría de Supply Chain',
      'Diseño de cadenas de suministro',
      'Análisis de redes de transporte',
      'Planificación estratégica',
      'Optimización de costos',
    ],
  },
  {
    title: 'Licitaciones & proveedores',
    items: [
      'Licitaciones de transporte',
      'Licitación de depósitos',
      'Evaluación de proveedores',
      'Gestión de subcontratistas',
    ],
  },
  {
    title: 'Implementación & almacenaje',
    items: [
      'Desarrollo e implementación de operaciones',
      'Warehousing',
      'Soluciones de almacenaje',
      'Autoelevadores',
    ],
  },
  {
    title: 'Control & mejora',
    items: [
      'Procesos y procedimientos',
      'KPIs y SLA',
      'Excelencia operacional',
      'Mejora continua',
    ],
  },
]

export const TRANSPORT_SERVICES = [
  'Transporte terrestre local',
  'Transporte terrestre nacional',
  'Operaciones internacionales cuando corresponda',
  'Operaciones multimodales',
  'Cargas generales',
  'Cargas industriales',
  'Operaciones IMO cuando corresponda',
  'Modelo de flota propia',
  'Modelo outsourcing / 3PL',
  'Gestión integral de transportistas',
]

export const TRANSPORT_CAPACITIES = [
  { label: 'Bateas', value: 'hasta 35 TN' },
  { label: 'Chasis y acoplado', value: 'aprox. 30 TN' },
  { label: 'Capacidad por unidad', value: 'hasta 28 pallets' },
  { label: 'Alternativas livianas', value: 'desde aprox. 500 kg' },
]

export const CONTROL_TOWER_FUNCTIONS = [
  'Seguimiento operacional',
  'Coordinación operativa',
  'Account Manager',
  'Administración',
  'Pago a proveedores',
  'HSE',
  'Tecnología',
  'Sustentabilidad',
  'Control documental',
  'Call Center post carga',
  'Seguimiento de transportes',
  'KPIs',
  'Medición de SLA',
  'Evaluación de proveedores',
]

export const OPERATION_FLOW = [
  'Carga',
  'Transportista',
  'Documentación',
  'Viaje',
  'Monitoreo',
  'Entrega',
  'KPI',
]

export const HSE_GROUPS = [
  {
    title: 'Cumplimiento & auditoría',
    items: [
      'Auditorías HSE',
      'Seguimiento de legislación',
      'Matriz legal de seguridad y medio ambiente',
      'Controles de cumplimiento',
      'Gestión de incumplimientos',
      'Evaluación de subcontratistas',
      'Auditorías a transportistas',
      'Contratación de proveedores',
    ],
  },
  {
    title: 'Operación segura',
    items: [
      'Checklist de unidades',
      'Control de extintores',
      'Control de neumáticos',
      'Mantenimiento preventivo',
      'Mantenimiento correctivo',
      'EPP',
      'Simulacros',
    ],
  },
  {
    title: 'Incidentes & emergencias',
    items: [
      'Gestión de incidentes',
      'Investigación de accidentes',
      'Planes de acción',
      'Respuesta ante emergencias',
    ],
  },
]

export const HSE_TRAININGS = [
  'Manejo defensivo',
  'RCP',
  'Primeros auxilios',
  'Uso de extintores',
  'Control de emergencias',
  'Incidentes en tránsito',
  'Derrames',
  'Incendio',
  'Fugas',
  'Sistemas TMS / WMS',
  'Inducciones de clientes',
]

export const FACILITY_UNITS = [
  {
    title: 'Limpieza corporativa e industrial',
    intro: 'Oficinas, empresas e industrias, con procesos eficientes y horarios adaptados a la operación.',
    items: [
      'Oficinas y espacios corporativos',
      'Plantas e instalaciones industriales',
      'Limpieza integral',
      'Desinfección',
      'Horarios adaptados a la operación',
      'Productos sustentables / ecológicos cuando corresponda',
    ],
    image: IMAGES.facility,
  },
  {
    title: 'Mantenimiento técnico',
    intro: 'Personal capacitado y matriculado cuando la actividad lo requiere.',
    items: [
      'Electricidad',
      'Plomería',
      'Gas',
      'Pintura',
      'Mantenimiento preventivo',
      'Mantenimiento correctivo',
      'Reparaciones',
      'Restauración de superficies',
      'Verificaciones y ensayos',
    ],
    image: IMAGES.maintenance,
  },
  {
    title: 'Control de plagas',
    intro: 'Control urbano e industrial, con línea de tratamiento ecológica disponible cuando corresponda.',
    items: [
      'Plagas urbanas',
      'Roedores',
      'Aves',
      'Murciélagos',
      'Saneamiento ambiental',
      'Control industrial',
      'Protección de granos y semillas',
      'Instalaciones de almacenamiento, silos, bolsas y depósitos',
    ],
    image: IMAGES.warehouse,
  },
  {
    title: 'Parquización y poda en altura',
    intro: 'Espacios verdes bajo control, con personal capacitado y protocolos de seguridad en altura.',
    items: [
      'Mantenimiento de espacios verdes',
      'Servicios hortícolas indoor / outdoor',
      'Paisajismo y mantenimiento integral',
      'Prevención de caída de ramas',
      'Saneamiento del árbol y crecimiento saludable',
      'Mejora de iluminación y ventilación',
      'Control de tamaño e interferencia con edificios, cables e infraestructura',
    ],
    image: IMAGES.greenSpaces,
  },
]

export const TECH_CAPABILITIES = [
  { title: 'Automatización', text: 'Tareas repetitivas de gestión resueltas con herramientas propias y macros.' },
  { title: 'Business Intelligence', text: 'Información operativa consolidada para análisis y toma de decisiones.' },
  { title: 'Dashboards', text: 'Tableros de operación, cumplimiento y estado documental.' },
  { title: 'Generación de KPIs', text: 'Indicadores definidos con el cliente y medidos de forma sistemática.' },
  { title: 'Plataformas web', text: 'Acceso del cliente al estado de su operación desde el navegador.' },
  { title: 'Control documental', text: 'Flota, transportista, chofer, camión y acoplado bajo seguimiento.' },
  { title: 'TMS / WMS', text: 'Trabajo sobre sistemas de transporte y almacén, propios o del cliente.' },
  { title: 'Integraciones', text: 'Conexión con proveedores de monitoreo y sistemas del cliente.' },
  { title: 'Reportes y planificación', text: 'Reportes periódicos y planificación de operaciones y recursos.' },
]

export const SUSTAINABILITY_ITEMS = [
  'Medición de huella de carbono',
  'Reportes mensuales de CO₂',
  'Análisis de operaciones',
  'Oportunidades de modernización de flota',
  'Tecnologías sustentables',
  'Reducción de impacto',
  'Indicadores ambientales',
  'Mejora continua',
]

export const RABEMAR_MODEL = [
  { code: '01', title: 'Diagnóstico', text: 'Entendemos la operación y las necesidades.' },
  { code: '02', title: 'Diseño', text: 'Construimos la solución y definimos procesos.' },
  { code: '03', title: 'Implementación', text: 'Coordinamos equipos, proveedores y tecnología.' },
  { code: '04', title: 'Control', text: 'Medimos operación, cumplimiento, SLA y KPIs.' },
  { code: '05', title: 'Optimización', text: 'Detectamos oportunidades y ejecutamos mejoras.' },
]

export const VALUES = [
  'Especialización',
  'Innovación',
  'Seguridad',
  'Optimización',
  'Transparencia',
  'Sustentabilidad',
  'Mejora continua',
]
